const kinds = ['rune', 'weapon', 'item'] as const;
export type InventoryItemKind = typeof kinds[number];
export const INVENTORY_ITEM_KINDS: readonly InventoryItemKind[] = kinds;
